import { render, staticRenderFns } from "./editClue.vue?vue&type=template&id=1990cec2&scoped=true&"
import script from "./editClue.vue?vue&type=script&lang=js&"
export * from "./editClue.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/mediaDetails/mediaCreat.less?vue&type=style&index=0&id=1990cec2&lang=less&scoped=true&"
import style1 from "./editClue.vue?vue&type=style&index=1&id=1990cec2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1990cec2",
  null
  
)

component.options.__file = "editClue.vue"
export default component.exports